<template>
    <ordering-table-feature-placeholder
        icon-class="fa fa-sitemap"
        title="Centre de profits"
        description="Cette section servira à structurer les centres de profits liés à la commande à table. L'écran est visible dans le back-office, mais la fonctionnalité n'est pas encore prête à être utilisée côté client."
        preview-title="Liste des centres de profits"
        empty-title="Aucun centre de profits disponible"
        empty-description="Aucun centre de profits ne peut encore être configuré ou exploité ici. La fonctionnalité sera activée lorsqu'elle sera finalisée pour l'usage client."
        :columns="['Nom', 'Canal', 'Règles', 'Statut']" />
</template>

<script>
import OrderingTableFeaturePlaceholder from "./components/OrderingTableFeaturePlaceholder.vue";

export default {
    components: {
        OrderingTableFeaturePlaceholder,
    },
};
</script>
